import { IOptions } from './options';

export enum EtapaParalisacao {
  Validacao,
  Assinatura,
  Transmissao,
}

export const etapaParalisacaoOptions: IOptions[] = [
  { label: 'Validação PVA', value: EtapaParalisacao.Validacao },
  { label: 'Assinatura', value: EtapaParalisacao.Assinatura },
  { label: 'Transmissão', value: EtapaParalisacao.Transmissao },
];

export const parseEtapaParalisacaoToQueryParam = (
  etapa: EtapaParalisacao,
): string => {
  switch (etapa) {
    case EtapaParalisacao.Validacao:
      return 'Validacao';
    case EtapaParalisacao.Assinatura:
      return 'Assinatura';
    case EtapaParalisacao.Transmissao:
      return 'Transmissao';
  }
};

export const parseEtapaParalisacaoDescricao = (etapa: string): string => {
  switch (etapa) {
    case 'Validacao':
      return 'Validação PVA';
    case 'Assinatura':
      return 'Assinatura';
    case 'Transmissao':
      return 'Transmissão';
    default:
      return '';
  }
};
